import { DeprecatedCloseIcon as Close, Tooltip } from '@lokalise/louis';
import { useTheme } from '@lokalise/styled';
import { useState } from 'react';

import isEllipsisActive from '@app/utils/isEllipsisActive';

import { Email, EmailRemove, EmailWrapper } from './styles';

type EmailTagProps = {
    email: string;
    valid: boolean;
    onClose: (email: string) => void;
};

const EmailTag = ({ email, onClose, valid }: EmailTagProps) => {
    const [emailEl, setEmailRef] = useState<HTMLElement | null>(null);

    const ellipsisView = isEllipsisActive(emailEl);

    const theme = useTheme();

    return (
        <EmailWrapper $invalid={!valid}>
            <Tooltip tooltip={ellipsisView && email}>
                <Email $invalid={!valid} ref={setEmailRef}>
                    {email}
                </Email>
            </Tooltip>
            <EmailRemove
                role="button"
                tabIndex={0}
                aria-label={`Remove ${email}`}
                onClick={() => onClose(email)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        onClose(email);
                    }
                }}
            >
                <Close size="16px" color={theme.color.custom.content.secondary} />
            </EmailRemove>
        </EmailWrapper>
    );
};

export default EmailTag;
